// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmFunds-Dialog_cls1__MmfHY","cls2":"ConfirmFunds-Dialog_cls2__B07yD ConfirmFunds-Dialog_cls1__MmfHY"};